import { Injectable } from '@angular/core'

export enum LocalStorageKey {
  LIBRARY__SHOW_ALL_RATE_CARD_ITEMS = 'showAllRateCardItems',
}

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  /**
   * Set an item in local storage
   * @param key The key to store the value under
   * @param value The value to store
   */
  set(key: string, value: any): void {
    try {
      const serializedValue = JSON.stringify(value)
      localStorage.setItem(key, serializedValue)
    } catch (error) {
      console.error('Error saving to local storage', error)
    }
  }

  /**
   * Get an item from local storage
   * @param key The key to retrieve
   * @returns The stored value or null if not found
   */
  get<T>(key: string): T | null {
    try {
      const item = localStorage.getItem(key)
      return item ? JSON.parse(item) : null
    } catch (error) {
      console.error('Error getting from local storage', error)
      return null
    }
  }

  /**
   * Remove an item from local storage
   * @param key The key to remove
   */
  remove(key: string): void {
    try {
      localStorage.removeItem(key)
    } catch (error) {
      console.error('Error removing from local storage', error)
    }
  }

  /**
   * Clear all items from local storage
   */
  clear(): void {
    try {
      localStorage.clear()
    } catch (error) {
      console.error('Error clearing local storage', error)
    }
  }

  /**
   * Check if a key exists in local storage
   * @param key The key to check
   * @returns True if the key exists, false otherwise
   */
  exists(key: string): boolean {
    return localStorage.getItem(key) !== null
  }
}
